import { useCallback } from 'react';

import { useKeycloak } from '../KeycloakContext';

const useLogout = () => {
  const { keycloak } = useKeycloak();

  const logout = useCallback(async () => {
    // make sure we wait until success logout before redirect
    localStorage.removeItem('kcRefreshToken');
    localStorage.removeItem('kctoken');
    localStorage.setItem('logout-event', Date.now().toString());
    await keycloak?.logout({
      redirectUri: `${window.location.origin}`,
    });
  }, [keycloak]);

  return logout;
};

export default useLogout;
